<template>
    <div class="modal">
        <div class="modal-content">
            <div class="modal-heading">
                <h3 class="modal-title">{{ title }}</h3>
                <button
                    @click="closeModal()"
                    class="modal-close">
                    <SvgIcon 
                        icon="icon-close"
                        title="Close modal">
                    </SvgIcon>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
            <div class="modal-body">
                <div v-html="body"></div>
            </div>
            <div v-if="btnLabel" class="modal-footer">
                <button @click="closeModal()" class="ecm-btn-text">{{ btnLabel }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '../main.js';
import { store } from '../store/store';
import SvgIcon from './SvgIcon.vue';

export default {
    name: 'Modal',
    components: {
        SvgIcon
    },
    props: {
        title: {
            type: String
        },
        body: {
            type: String
        },
        btnLabel: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            
        }
    },
    created() {
        // Event bus close modal handler
        eventBus.$on('closeModal', this.closeModal);
    },
    methods: {
        closeModal() {
            store.commit('setModal', null);
        }
    }
}

</script>

<style scoped>
.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, .75);
    z-index: 10100;
}
.modal-content {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    width: 100%;
    max-width: 480px;
    max-height: 95vh;
    padding: 1rem;
    border-radius: 4px;
    margin: 1rem;
    overflow: hidden;
}
.modal-content.dark {
    background-color: #212121;
    color: #eee;
}
.modal-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--km-theme-color);
    color: var(--km-theme-text-color);
    padding: 1rem;
    margin: -1rem -1rem 1rem -1rem;
}
.modal-title {
    font-size: 1rem;
    color: var(--km-theme-text-color);
    margin: 0;
}
.modal-close {
    border: none !important;
    opacity: .5;
}
.modal-close:hover {
    background-color: transparent !important;
    opacity: 1;
}
.modal-body {
    overflow-y: auto;
    margin: 0 auto 1rem auto;
}
.modal-footer {
    text-align: center;
}
</style>
